import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M9.775 16.042H6.86c-.92 0-1.667-.747-1.667-1.667v-8.75c0-.92.746-1.667 1.667-1.667h5.208L15.609 7.5v1.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M15.4 7.708h-3.54V4.167M16 16l-1.293-1.293M11 13.155a2.155 2.155 0 1 1 4.31 0 2.155 2.155 0 0 1-4.31 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);